import { FacebookLogo } from './FooterLogos/FacebookLogo';
import { InstagramLogo } from './FooterLogos/InstagramLogo';
import { LinkedInLogo } from './FooterLogos/LinkedInLogo';
import { XLogo } from './FooterLogos/XLogo';

const Socials = () => {
  return (
    <div className="col-auto grid auto-cols-max grid-flow-col auto-rows-max gap-3">
      <InstagramLogo />
      <LinkedInLogo />
      <XLogo />
      <FacebookLogo />
    </div>
  );
};

export default Socials;
